import Vue from 'vue'
import { mapActions, mapState } from 'vuex'
import ChatRoom from '@/models-ts/chat/ChatRoom'
import { RootState } from '@/store'

export default Vue.extend({
  computed: {
    ...mapState<RootState>({
      roomId: (state: RootState) => state.chatNew.openedRoomId,
      isAppLoading: (state: RootState) => state.vacancyChat.application.isLoading,
    }),
    applicationId() {
      const { applicationId } = ChatRoom.parseRoomId(this.roomId)
      return applicationId
    },
  },
  methods: {
    ...mapActions({
      getApplication: 'vacancyChat/getApplication',
    }),
    waitRefreshApplication() {
      const promise = new Promise(async (resolve, reject) => {
        try {
          const res = await this.refreshApplication()
          this.$nextTick(() => resolve(res))
        } catch (err) {
          reject(err)
        }
      })
      return promise
    },
    async refreshApplication() {
      if (this.isAppLoading) return

      await this.getApplication(this.applicationId)
    },
  },
})
